<div class="main p-1">
  <img class="d-block m-auto" src="assets/icons/iconfinder_error.svg" />
  <div class="text-center font-weight-normal my-1 restricted-msg">
    <p [innerHTML]="text"></p>
  </div>
</div>
